module.exports = __webpack_public_path__ + "static/media/bible.f6682ad2.svg";